import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

export const text = {
	definition: 'A Decision Maker has the power to create the change you want. If you know who that is, add them now.',
	noneTip: 'Not sure? We’ll find and add the right one when you reach 10 signatures.',
	autoAddedDefinition: 'Great news—we’ve found Decision Makers for your petition!',
	edit: 'You can edit this anytime.',
	autoAddedTip: 'Reaching out now can help you get answers, updates, or a faster response.',
	manualAddedTip: 'Reaching out to Decision Makers now can help you get answers, updates, or a faster response.',
	emailAction: 'A quick email makes a difference.',
	signatureGoal: 'At 100 signatures, we’ll reach out too—because we’re invested in your success.',
};

export function DmOverview({
	dmSources,
}: {
	dmSources: 'none' | 'partial_manual_add' | 'only_auto_add' | 'no_email_dms';
}): React.JSX.Element {
	return (
		<Box sx={{ borderBottom: '1px solid lightGrey' }} data-testid="dm-overview" p={24}>
			<Heading as="h3" size="h4" mb={16}>
				Reach who matters
			</Heading>
			<Box
				sx={{
					borderRadius: 'standard',
					height: 'auto',
					alignSelf: 'center',
					flex: 1,
				}}
			>
				{dmSources === 'none' && <NoneDm textDefinition={text.definition} textTip={text.noneTip} />}
				{dmSources === 'only_auto_add' && (
					<AutoAddedDm
						textDefinition={text.autoAddedDefinition}
						textTip={text.autoAddedTip}
						textEdit={text.edit}
						textGoal={text.signatureGoal}
					/>
				)}
				{(dmSources === 'partial_manual_add' || dmSources === 'no_email_dms') && (
					<ManualAddDm textTip={text.manualAddedTip} textAction={text.emailAction} textGoal={text.signatureGoal} />
				)}
			</Box>
		</Box>
	);
}

function NoneDm({ textDefinition, textTip }: { textDefinition: string; textTip: string }) {
	return (
		<>
			<Text as="p">{textDefinition}</Text>
			<Text as="p" sx={{ mt: '24px', fontWeight: 'bold' }}>
				{textTip}
			</Text>
		</>
	);
}

function AutoAddedDm({
	textDefinition,
	textTip,
	textEdit,
	textGoal,
}: {
	textDefinition: string;
	textTip: string;
	textEdit: string;
	textGoal: string;
}) {
	return (
		<>
			<Text as="p">
				<Text as="strong">{textDefinition}</Text> {textEdit}
			</Text>
			<Text as="p" mt={24}>
				{textTip} <Text as="strong">{text.emailAction}</Text>
			</Text>
			<Text as="p" mt={24}>
				{textGoal}
			</Text>
		</>
	);
}

function ManualAddDm({ textTip, textAction, textGoal }: { textTip: string; textAction: string; textGoal: string }) {
	return (
		<>
			<Text as="p">
				{textTip} <Text as="strong">{textAction}</Text>
			</Text>
			<Text as="p" mt={24}>
				{textGoal}
			</Text>
		</>
	);
}
